export function isNormalKanbanColumn(column) {
	return column?.systemType === 'NORMAL'
}

export function resolveContextualCreateTarget(columns, targetColumnId) {
	if (targetColumnId === null || targetColumnId === undefined) return null
	const target = columns.find(column => String(column.columnId) === String(targetColumnId))
	return isNormalKanbanColumn(target) ? target.columnId : null
}
